import { render, staticRenderFns } from "./EtagStatusList.vue?vue&type=template&id=328c1d28"
import script from "./EtagStatusList.vue?vue&type=script&lang=js"
export * from "./EtagStatusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports